function aboutCarousel() {
	var owl4 = $(".about-founders .owlCarousel");
	owl4.owlCarousel({
		loop:false,
		responsive:{
			0:{items:1},
			640:{items:2},
			1280:{items:3},
		},
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		loop: true,
		center:true,
	});
	$(".about-founders .owlControl .right").click(function() {
		owl4.trigger('next.owl.carousel');
	});
	$(".about-founders .owlControl .left").click(function() {
		owl4.trigger("prev.owl.carousel");
	});
}